import { BCMSRecord, useBCMSContext, useBCMSModal, useRoute, useStateManager, useWorkflow } from "@bcm-dev/bcms-vite";
import EDEStatementsPageContainer from "components/EDEStatements/shared/containers/EDEStatementsPageContainer";
import Classes from "model";
import "./styles.css";
import "./mobile.css";
import ProfilePicker from "components/shared/widgets/ProfilePicker";
import { Profile } from "model";
import EDEStatementsEnrollmentPageContentView from "components/EDEStatements/shared/views/EDEStatementsEnrollmentPageContentView";

/**
 * @function EDEStatementsEnrollmentProfilePage
 * @return {React.Component}
 * @exported true
 * @description The "EDE Statements Enrollment Profile" page.
 */
export default function EDEStatementsEnrollmentProfilePage(props) {
  // Initalize all model classes
  const context = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, context);
  const { nextStep } = useWorkflow() ?? {};

  // Sets the values for the data and ui variables
  const data = { ...getDefaultPageData(), ...props.data ?? {} };
  const ui = { ...getDefaultPageUI(), ...props.ui ?? {} };
  // The state to be passed to the state manager
  const state = { data, ui };
  const navigate = useRoute();
  
  // :: React.state, React.setState -> OBJECT
  // Function to initalize the controller for the state manager
  const controller = (state, setState) => ({
      data: state.data, // Set the data property of the controller
      ui: state.ui, // Set the ui property of the controller
      onSelectClick: evt => {
        nextStep();
      }
  });
  
  return(
    <EDEStatementsPageContainer className={ `ede-statements-enrollment-profile-page` } state={ state } controller={ controller }>
        <PageContent/>
    </EDEStatementsPageContainer>
  );
}

/**
 * @name getDefaultPageData
 * @param {Void} 
 * @returns {OBJECT}
 * @description Hook to return the default data required by the page
 */
export const getDefaultPageData = (profiles) => {
  const _profiles = profiles ?? Profile.initAll();
  const selectedProfileID = _profiles[0].id;

  return {
    profiles: profiles ?? Profile.initAll(),
    selectedProfileID
  };
};

/**
* @name getDefaultPageUI
* @param {Void} 
* @return {OBJECT}
* @description Hook to return the default ui required by the page.
*/
export const getDefaultPageUI = () => {
  
};

/**
 * @function PageContent
 * @return {React.Component}
 * @exported false
 * @description The content for this page.
 */
function PageContent(props) {
  const { data, ui, onSelectClick } = useStateManager();

  return (
    <EDEStatementsEnrollmentPageContentView showABI22PageFooterView={ true } showEDEStatementsPageFooterView={ false }>
      <div className="flex-container flex-vertical flex-width">
        <ProfilePicker profileID={ data.selectedProfileID } profiles={ data.profiles }
        title={ `Select Profile For Statements` }
          ui={ { currentProfileSelectIsActive: false } }
          onSelectClick={ onSelectClick } />
      </div>
    </EDEStatementsEnrollmentPageContentView>
  );
}
